<div *ngIf="isShowing && !isMobile" class="popupSelector-container">
  <div class="popupSelector">

    <div class="popupSelector-title">
      <h5 i18n>Seleccione cómo desea visualizar el estudio</h5>
      <p class="popupSelector-subtitle" i18n>Elija la vista que mejor se adapte a sus necesidades.</p>
    </div>

    <div class="buttons-container">

      <button
        type="button"
        class="btn btn-access"
        [class.btn-disabled]="!bookUrl"
        [class.btn-selected]="selectedOption === 'book'"
        [disabled]="!bookUrl"
        (click)="selectAndGoTo('book', bookUrl)">
        <span class="btn-check-badge" *ngIf="selectedOption === 'book'">
          <span class="material-icons">check_circle</span>
        </span>
        <div class="btn-header">
          <svg width="33" height="35" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6H39L52 19V58H16V6Z" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M39 6V20H52" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M24 30H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 40H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 50H36" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
        </svg>
          <div class="btn-header-text">
            <span class="btn-label" i18n>Visor paciente</span>
            <small class="btn-sublabel" i18n>Consulte el informe junto con las imágenes del estudio en un mismo visor.</small>
          </div>
        </div>
        <div class="btn-media-placeholder">
          <img src="assets/img/acceso/Visor_paciente.png" alt="Visor paciente" class="btn-media" />
        </div>
        <small class="btn-sublabel btn-sublabel-unavailable" *ngIf="!bookUrl" i18n>No disponible</small>
      </button>

      <button
        type="button"
        class="btn btn-access"
        [class.btn-disabled]="!visorUrl"
        [class.btn-selected]="selectedOption === 'visor'"
        [disabled]="!visorUrl"
        (click)="selectAndGoTo('visor', visorUrl)">
        <span class="btn-check-badge" *ngIf="selectedOption === 'visor'">
          <span class="material-icons">check_circle</span>
        </span>
        <div class="btn-header">
          <img src="assets/icons/icono_monitor_azul.svg" class="btn-icon" alt="monitor" />
          <div class="btn-header-text">
            <span class="btn-label" i18n>Visor médico especialista</span>
            <small class="btn-sublabel" i18n>Explore el estudio completo en un visor DICOM web más avanzado.</small>
          </div>
        </div>
        <div class="btn-media-placeholder">
          <img src="assets/img/acceso/Visor_especializado.png" alt="Visor médico especialista" class="btn-media" />
        </div>
        <small class="btn-sublabel btn-sublabel-unavailable" *ngIf="!visorUrl" i18n>No disponible</small>
      </button>

    </div>

    <div class="bottom-texts">
      <div  class="bottom-text-row" *ngIf="reportUrl">
        <svg width="25" height="25" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6H39L52 19V58H16V6Z" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M39 6V20H52" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M24 30H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 40H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 50H36" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
        </svg>
        <a (click)="goTo(reportUrl)" class="report-link" i18n>Pulse aquí si solamente desea ver el informe</a>
      </div>
      <div class="bottom-text-row help-text-container">
        <img src="assets/icons/icono_pregunta_azul.svg" class="bottom-row-icon" alt="ayuda" />
        <div class="help-text-body">
          <span class="help-title" i18n>¿No estás seguro qué opción elegir?</span>
          <span class="help-desc" i18n>Ambas opciones permiten acceder a la información completa del estudio.</span>
        </div>
      </div>
    </div>

  </div>
</div>

<div *ngIf="isShowing && isMobile" class="popupSelector-container">
  <div class="popupSelector popupSelector-mobile">

    <div class="popupSelector-title">
      <h5 i18n>Seleccione cómo desea visualizar el estudio</h5>
      <p class="popupSelector-subtitle" i18n>Elija la vista que mejor se adapte a sus necesidades.</p>
    </div>

    <div class="buttons-container">

      <button
        type="button"
        class="btn btn-access"
        [class.btn-disabled]="!bookUrl"
        [class.btn-selected]="selectedOption === 'book'"
        [disabled]="!bookUrl"
        (click)="selectAndGoTo('book', bookUrl)">
        <span class="btn-check-badge" *ngIf="selectedOption === 'book'">
          <span class="material-icons">check_circle</span>
        </span>
        <div class="btn-header">
          <svg width="45" height="50" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6H39L52 19V58H16V6Z" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M39 6V20H52" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M24 30H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 40H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 50H36" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
        </svg>
          <div class="btn-header-text">
            <span class="btn-label" i18n>Visor paciente</span>
            <small class="btn-sublabel" i18n>Consulte el informe junto con las imágenes del estudio en un mismo visor.</small>
          </div>
        </div>
        <div class="btn-media-placeholder">
          <img src="assets/img/acceso/Visor_paciente.png" alt="Visor paciente" class="btn-media" />
        </div>
        <small class="btn-sublabel btn-sublabel-unavailable" *ngIf="!bookUrl" i18n>No disponible</small>
      </button>

      <button
        type="button"
        class="btn btn-access"
        [class.btn-disabled]="!visorUrl"
        [class.btn-selected]="selectedOption === 'visor'"
        [disabled]="!visorUrl"
        (click)="selectAndGoTo('visor', visorUrl)">
        <span class="btn-check-badge" *ngIf="selectedOption === 'visor'">
          <span class="material-icons">check_circle</span>
        </span>
        <div class="btn-header">
          <img src="assets/icons/icono_monitor_azul.svg" class="btn-icon" alt="monitor" />
          <div class="btn-header-text">
            <span class="btn-label" i18n>Visor médico especialista</span>
            <small class="btn-sublabel" i18n>Explore el estudio completo en un visor DICOM web más avanzado.</small>
          </div>
        </div>
        <div class="btn-media-placeholder">
          <img src="assets/img/acceso/Visor_especializado.png" alt="Visor médico especialista" class="btn-media" />
        </div>
        <small class="btn-sublabel btn-sublabel-unavailable" *ngIf="!visorUrl" i18n>No disponible</small>
      </button>

    </div>

    <div class="bottom-texts">
      <div  class="bottom-text-row" *ngIf="reportUrl">
        <svg width="25" height="25" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 6H39L52 19V58H16V6Z" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M39 6V20H52" stroke="#FFC700" stroke-width="5" stroke-linejoin="round"/>
          <path d="M24 30H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 40H43" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
          <path d="M24 50H36" stroke="#FFC700" stroke-width="5" stroke-linecap="round"/>
        </svg>
        <a (click)="goTo(reportUrl)" class="report-link" i18n>Pulse aquí si solamente desea ver el informe</a>
      </div>
      <div class="bottom-text-row help-text-container">
        <img src="assets/icons/icono_pregunta_azul.svg" class="bottom-row-icon" alt="ayuda" />
        <div class="help-text-body">
          <span class="help-title" i18n>¿No estás seguro qué opción elegir?</span>
          <span class="help-desc" i18n>Ambas opciones permiten acceder a la información completa del estudio.</span>
        </div>
      </div>
    </div>

  </div>
</div>
